import { select, takeEvery, SelectEffect, delay, CallEffect } from 'redux-saga/effects';

import { RESUME_SUBSCRIPTION, UPGRADE_ACCOUNT } from 'js/actionCreators/userAccountAction';
import { ACCOUNT_TYPES } from 'js/config/consts';
import isElectron from 'js/shared/helpers/isElectron';

export function* redirectToPricingPage(): Generator<SelectEffect | CallEffect, void, string> {
  const currentPath = yield select(state => state.router?.location?.pathname || '');
  const accountType = yield select(state => state.auth?.currentUser?.accountType);
  const redirectURL = `/app${currentPath}`;
  window.localStorage.setItem('checkout-success-redirect', redirectURL);
  const params = new URLSearchParams({
    referrer: isElectron() ? 'electron' : 'vsc',
    action: 'upgrade',
    accountType
  });

  yield delay(300);

  let redirect = '/pricing/';
  if (isElectron()) {
    redirect = '/pricing/?referrer=electron';
  }
  if (accountType !== ACCOUNT_TYPES.FREE) {
    redirect = `/account/subscriptions?${params.toString()}`;
  }

  window.location.href = redirect;
}

export function* redirectToSubscriptionManagement(): Generator {
  const params = new URLSearchParams({
    referrer: isElectron() ? 'electron' : 'vsc',
    action: 'resume'
  });
  window.location.href = `/account/subscriptions?${params.toString()}`;
}

function* userAccountSagas() {
  yield takeEvery(UPGRADE_ACCOUNT, redirectToPricingPage);
  yield takeEvery(RESUME_SUBSCRIPTION, redirectToSubscriptionManagement);
}

export default userAccountSagas;
